import { motion } from "framer-motion"
import {
    containerAnimation,
    childAnimation,
    imageAnimation,
    fastAnimation,
    fastContainerAnimation,
    lineAnimation,
    hoverAnimation
} from '../data/animations'

const UStock = () => {
    return (
        <div className='overflow-hidden'>
            <div className='  relative  '>
                <motion.div
                    className='h-[calc(100vh-6rem)] w-full relative z-10  pt-20 pb-10  px-[2.3%]'
                    initial="initial"
                    animate="animate"
                    viewport={{ once: false, amount: 0 }}
                    variants={containerAnimation}
                >
                    <div className='h-full w-full flex flex-col justify-between px-[6%]'>
                        <motion.div
                            className='flex justify-center md:justify-end'
                            variants={childAnimation}
                        >
                            <img src="/images/u-stock/u-stock-white.svg" alt="" className=' w-2/3 md:w-72 ' />
                        </motion.div>


                        <div className='flex flex-col md:flex-row justify-center  md:justify-end items-center md:items-end px-[2.3%] md:px-0'>
                            <motion.p
                                className='text-white text-28 tracking-[0.21rem] md:mb-2 md:mr-8 !block mb-10  '
                                variants={childAnimation}
                            >
                                TİCARİ DEPO ALANLARI
                            </motion.p>
                            <motion.img
                                src="/images/u-stock/ulus-w.svg"
                                alt=""
                                className=' w-1/3 md:w-28 flex-none'
                                variants={childAnimation}
                            />
                        </div>
                    </div>
                </motion.div>

                <motion.div
                    className='absolute top-0 left-0 h-full w-full   px-[2.3%]'
                    initial="initial"
                    animate="animate"
                    variants={containerAnimation}
                >
                    <motion.img
                        src="/images/u-stock/1.jpg"
                        alt=""
                        className='w-full h-full object-cover'
                        variants={imageAnimation}
                    />
                </motion.div>
            </div>



            <div className='  relative py-5 pb-0 pt-0  h-full w-full'>
                <motion.div
                    className=' top-0 left-0 h-full w-full  py-5 pr-[2.3%]'
                    initial="initial"
                    whileInView="animate"
                    viewport={{ once: false, amount: 0 }}
                    variants={containerAnimation}
                >
                    <motion.img
                        src="/images/u-stock/2.svg"
                        alt=""
                        className='w-full h-full object-contain lg:object-contain lg:object-right'
                        variants={imageAnimation}
                    />
                </motion.div>
            </div>




            <div className='  relative  px-[2.3%] pb-0'>
                <motion.div
                    className='min-h-96 md:h-[calc(100vh-6rem)] w-full relative z-10  pt-20 pb-10 px-[6%] flex items-end md:items-start'
                    initial="initial"
                    whileInView="animate"
                    viewport={{ once: false, amount: 0 }}
                    variants={containerAnimation}
                >
                    <div className='h-full w-full flex flex-col justify-between'>
                        <motion.div
                            className='flex  justify-center md:justify-end'
                            variants={childAnimation}
                        >
                            <div className='flex flex-col items-start md:w-1/2 lg:w-[33%] text-white md:text-[#231f20] font-montserrat'>
                                <h1 className=' text-28 mb-2 leading-[1.6rem]'>KONFORUN <br /> KOLAYLIĞIN MERKEZİ</h1>
                                <p className='text-16 '>Antalya, İzmir ve Denizli'yi bağlayan otoban bağlantısına yalnızca 500m mesafede, lojistiğin nabzını tutan bir konum! <br />
                                    650 m² kapalı alanıyla işlevsellikte sınır tanımayan bir yapı, 1300 m² arsa payı geniş bir hareket alanı sunuyor. </p>
                            </div>
                        </motion.div>



                    </div>
                </motion.div>

                <motion.div
                    className='absolute top-0 left-0 h-full w-full px-[2.3%] pb-0'
                    initial="initial"
                    whileInView="animate"
                    viewport={{ once: false, amount: 0 }}
                    variants={containerAnimation}
                >
                    <motion.img
                        src="/images/u-stock/3.jpg"
                        alt=""
                        className='w-full h-full object-cover'
                        variants={imageAnimation}
                    />
                </motion.div>
            </div>




            <motion.div
                className='  relative py-5 pb-0 pt-0  h-full w-full flex flex-col pr-[2.3%]'
                initial="initial"
                whileInView="animate"
                viewport={{ once: false, amount: 0 }}
                variants={containerAnimation}
            >


                <motion.div
                    className=' top-0 left-0 h-full w-full  py-5 pb-0 '
                    variants={childAnimation}
                >
                    <motion.img
                        src="/images/u-stock/4.svg"
                        alt=""
                        className='w-full h-full object-contain lg:object-contain lg:object-right'
                        variants={imageAnimation}
                    />
                </motion.div>

                <motion.div
                    className='ml-[2.3%] bg-black text-white flex md:justify-center text-24 lg:text-35   tracking-widest px-[6%] pt-10 md:pt-5 pb-10 md:pb-28'
                    variants={childAnimation}
                >
                    <h2 className='md:pr-[10%] '>KONUM AVANTAJIYLA GÜÇ SİZİNLE</h2>
                </motion.div>

            </motion.div>



            <motion.div
                className='  relative py-5 pb-0 pt-0  h-full w-full'
                initial="initial"
                whileInView="animate"
                viewport={{ once: false, amount: 0 }}
                variants={containerAnimation}
            >
                <motion.div
                    className=' top-0 left-0 h-full w-full  py-5 pb-0 px-[2.3%]'
                    variants={childAnimation}
                >
                    <motion.img
                        src="/images/u-stock/5.jpg"
                        alt=""
                        className='w-full h-full object-contain lg:object-contain lg:object-right'
                        variants={imageAnimation}
                    />
                </motion.div>
            </motion.div>

            <motion.div
                className='  relative pb-5  pt-0  h-full w-full'
                initial="initial"
                whileInView="animate"
                viewport={{ once: false, amount: 0 }}
                variants={containerAnimation}
            >
                <motion.div
                    className=' top-0 left-0 h-full w-full  pt-5 pb-0 px-[2.3%]'
                    variants={childAnimation}
                >
                    <motion.img
                        src="/images/u-stock/16.jpg"
                        alt=""
                        className='w-full h-full object-contain lg:object-contain lg:object-right'
                        variants={imageAnimation}
                    />
                </motion.div>
            </motion.div>



            <motion.div
                className='  relative pb-5  pt-0  h-full w-full'
                initial="initial"
                whileInView="animate"
                viewport={{ once: false, amount: 0 }}
                variants={containerAnimation}
            >
                <motion.div
                    className=' top-0 left-0 h-full w-full   pb-0 px-[2.3%]'
                    variants={childAnimation}
                >
                    <motion.img
                        src="/images/u-stock/6.jpg"
                        alt=""
                        className='w-full h-full object-contain lg:object-contain lg:object-right'
                        variants={imageAnimation}
                    />
                </motion.div>
            </motion.div>


            <div className='px-[2.3%] pb-5 '>
                <motion.div
                    className='bg-black px-[6%] flex justify-end py-20'
                    initial="initial"
                    whileInView="animate"
                    viewport={{ once: false, amount: 0 }}
                    variants={containerAnimation}
                >
                    <div className='flex flex-col md:w-full lg:w-[70%]'>
                        <motion.img
                            src='/images/u-stock/7.svg'
                            alt=""
                            className='hidden md:block w-full h-full object-contain lg:object-contain lg:object-right'
                            variants={imageAnimation}
                        />
                        <motion.div
                            className=' flex-col flex md:hidden space-y-5'
                            variants={childAnimation}
                        >
                            <img src='/images/u-stock/8.jpg' alt="" className='w-full h-full object-contain' />
                            <img src='/images/u-stock/9.jpg' alt="" className='w-full h-full object-contain' />

                            <img src='/images/u-stock/u-stock-white.svg' alt="" className='w-1/3  object-contain py-10' />
                        </motion.div>
                        <motion.div
                            className='flex flex-col items-start md:w-1/2 lg:w-[33%] text-white  font-montserrat'
                            variants={childAnimation}
                        >
                            <h1 className=' text-28 mb-2 leading-[1.6rem]'>BAĞIMSIZLIK VE <br /> ESNEKLİK</h1>
                            <p className='text-16 '>Antalya, İzmir ve Denizli'yi bağlayan otoban bağlantısına yalnızca 500m mesafede, lojistiğin nabzını tutan bir konum! <br />
                                650 m² kapalı alanıyla işlevsellikte sınır tanımayan bir yapı, 1300 m² arsa payı geniş bir hareket alanı sunuyor. </p>
                        </motion.div>
                    </div>

                </motion.div>

            </div>

            <motion.div
                className='  relative pb-5  pt-0  h-full w-full'
                initial="initial"
                whileInView="animate"
                viewport={{ once: false, amount: 0 }}
                variants={containerAnimation}
            >
                <motion.div
                    className=' top-0 left-0 h-full w-full   pb-0 px-[2.3%]'
                    variants={childAnimation}
                >
                    <motion.img
                        src="/images/u-stock/14.jpg"
                        alt=""
                        className='w-full h-full object-contain lg:object-contain lg:object-right'
                        variants={imageAnimation}
                    />
                </motion.div>
            </motion.div>


            <motion.div
                className='  relative pb-5  pt-0  h-full w-full'
                initial="initial"
                whileInView="animate"
                viewport={{ once: false, amount: 0 }}
                variants={containerAnimation}
            >
                <motion.div
                    className=' top-0 left-0 h-full w-full   pb-0 px-[2.3%]'
                    variants={childAnimation}
                >
                    <motion.img
                        src="/images/u-stock/13.jpg"
                        alt=""
                        className='w-full h-full object-contain lg:object-contain lg:object-right'
                        variants={imageAnimation}
                    />
                </motion.div>
            </motion.div>



            <div className='px-[2.3%] '>
                <motion.div
                    className='bg-black px-[6%] flex justify-end py-20'
                    initial="initial"
                    whileInView="animate"
                    viewport={{ once: false, amount: 0 }}
                    variants={containerAnimation}
                >
                    <div className=' w-full lg:w-[90%] flex flex-col lg:flex-row'>


                        <motion.div
                            className=' flex-col flex md:hidden space-y-5'
                            variants={childAnimation}
                        >
                            <img src='/images/u-stock/11.jpg' alt="" className='w-full h-full object-contain' />
                            <img src='/images/u-stock/12.jpg' alt="" className='w-full h-full object-contain' />

                            <img src='/images/u-stock/u-stock-white.svg' alt="" className='w-1/3  object-contain py-10' />
                        </motion.div>

                        <motion.div
                            className='flex md:flex-row flex-col pr-0 md:pr-5'
                            variants={childAnimation}
                        >
                            <div className='flex flex-col items-start  text-white   font-montserrat md:pt-10'>
                                <h1 className=' text-28 mb-2 leading-[1.6rem]'>U-STOCK, YALNIZCA BİR DEPO DEĞİL, AYNI ZAMANDA İŞİNİZİN BÜYÜMESİ İÇİN TASARLANMIŞ BİR TİCARİ ALAN.
                                </h1>
                                <p className='text-16 '>Şehrin merkezine kolay erişim, sağlam altyapı ve verimliliği önceliklendiren mimari tasarımıyla Ulus İnşaat kalitesinde…</p>
                            </div>
                        </motion.div>







                        <motion.img
                            src='/images/u-stock/10.svg'
                            alt=""
                            className='hidden  md:block  h-full object-contain lg:object-contain lg:object-right w-full lg:w-[64%]'
                            variants={imageAnimation}
                        />


                    </div>

                </motion.div>

            </div>




            <motion.div
                className='  relative py-5 pt-5  h-full w-full  pr-[2.3%] md:pr-[2.3%] pb-5 flex md:flex-row flex-col overflow-hidden '
                initial="initial"
                whileInView="animate"
                viewport={{ once: false, amount: 0 }}
                variants={containerAnimation}
            >
                <motion.div
                    className=' flex-col flex md:hidden space-y-5 w-full'
                    variants={childAnimation}
                >
                    <img src='/images/u-stock/17.png' alt="" className='w-full h-full object-contain' />


          
                </motion.div>


                <motion.div
                    className='hidden md:block top-0 left-0 h-full w-[61%] pb-0 flex-none '
                    variants={childAnimation}
                >
                    <motion.img
                        src="/images/u-stock/15.png"
                        alt=""
                        className='w-full h-full object-contain lg:object-contain lg:object-right'
                        variants={imageAnimation}
                    />
                </motion.div>

                <div
                    className=' bg-black text-white items-center flex md:justify-center text-24 lg:text-35   tracking-widest pl-8 pr-[6%] pt-10 md:pt-5 pb-10 
                 md:w-[39%] w-full'
                   
                >
                    <motion.h2  variants={childAnimation} className='md:pr-[10%] '>FONKSİYONEL KONUMU DİKKAT ÇEKİYOR</motion.h2>
                </div>

            </motion.div>
















            <div className='  w-full p-2.5 md:p-5 !pt-0'>

                <motion.div
                    className='h-full md:min-h-[calc(100vh-8rem)] w-full  relative overflow-hidden  bg-black '
                    initial="initial"
                    whileInView="animate"
                    viewport={{ once: false, amount: 0 }}
                    variants={containerAnimation}
                >

                    <div className='relative top-0 left-0 h-full w-full  flex flex-col justify-center z-20 px-[16.6%] md:px-0 '>
                        <div className=' flex flex-col w-full h-full  justify-center items-center  space-y-12 '>
                            <motion.div
                                className='relative w-2/3 md:w-64  pt-36'
                                variants={childAnimation}
                            >
                                <motion.img src='/images/u-stock/u-stock-white.svg' className='w-full' variants={childAnimation} />

                            </motion.div>



                            <motion.div
                                className=' flex flex-col items-center justify-center space-y-10'
                            >
                                <motion.div
                                    className='relative flex-none font-adobe border text-center border-[#e6e6e6] leading-tight py-2 px-10 text-[#e6e6e6]'
                                    variants={childAnimation}
                                >
                                    <motion.p className='text-24 md:text-35 font-medium' variants={childAnimation}>Detaylı Bilgi İçin</motion.p>
                                    <motion.a href='tel:05309740440' target='_blank' className='block text-28 md:text-45 font-bold' variants={childAnimation} whileHover={hoverAnimation.whileHover}>0 530 974 04 40</motion.a>
                                    <motion.a href='https://www.ulus.co' target='_blank' className='block text-24 md:text-35 leading-none mb-0.5' variants={childAnimation} whileHover={hoverAnimation.whileHover}>www.ulus.co</motion.a>

                                </motion.div>

                            </motion.div>

                            <motion.div
                                className='relative w-2/3 md:w-56 pb-20 '
                                variants={childAnimation}
                            >
                                <motion.img src='/images/projects/house/logo-guvence-ulus.svg' className='w-full' variants={childAnimation} />
                                <motion.img src='/images/projects/house/logo-guvence-ulus-text.svg' className='w-full absolute top-0' variants={childAnimation} />
                            </motion.div>
                        </div>
                    </div>
                </motion.div>
            </div>




        </div>
    )
}

export default UStock